import { render } from "./ConfirmUpdateDashboard.vue?vue&type=template&id=0ed4f820"
import script from "./ConfirmUpdateDashboard.vue?vue&type=script&lang=js"
export * from "./ConfirmUpdateDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__